import { send } from 'server';

import { TGetBingoScheduleResponse, TGetSiteSchedulesProps } from './types';

export const getBingoSchedule = ({
    casino,
    lobbyName
}: TGetSiteSchedulesProps): Promise<TGetBingoScheduleResponse> => send({
    ID: 81710,
    description: 'Bingo scheduled games request',
    responses: [81711, 81712],
    casino,
    lobbyName,
    pageNumber: 1,
    pageSize: 100
});
